/** Display-only: prefix with TM when the value does not already start with TM. */
export function formatTmNoForDisplay(tmNo: string | null | undefined): string {
  const s = String(tmNo ?? "").trim();
  if (!s) return "";
  if (/^tm/i.test(s)) return s;
  return `TM ${s}`;
}
